import * as requestFromServer from './bankImportCrud';
import { bankImportSlice, callTypes } from './bankImportSlice';
import {toast} from "react-toastify";
import {toastOption} from "../../../../../_metronic/_helpers";
import {actions as auth} from "../../../Auth";

const { actions } = bankImportSlice;

export const fetchBankImport = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
        .findBankImport(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.bankImportsFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const uploadfile = (formData) => dispatch => {

    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
        .uploadFile(formData)
        .then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const getDataTag = (id, type) => dispatch => {

    return requestFromServer
        .getDataTagById(id, type)
        .then(response => {
            const { data } = response.data;
            return data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callTypes: callTypes.list }));
        });
};

export const processDonation = (payload) => dispatch => {

    return requestFromServer
        .updateDonatur(payload)
        .then(response => {
            return response.data;
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callTypes: callTypes.list }));
        });
};
